/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Box = props => (
  <svg viewBox="0 0 400 400" width="1em" height="1em" {...props}>
    <path d="M197.3 198c1.2 1.2 2.8 1.8 4.4 1.8 1.6 0 3.2-.6 4.4-1.8l92.9-86.7c1.2-1.2 1.8-2.8 1.8-4.4 0-.8-.2-1.6-.5-2.4-.9-2.3-3.2-3.8-5.7-3.8h-44V7.8c0-3.4-2.8-6.2-6.2-6.2h-86.7c-3.4 0-6.2 2.8-6.2 6.2v92.9h-42.7c-2.5 0-4.8 1.5-5.7 3.8-.3.8-.5 1.6-.5 2.4 0 1.6.6 3.2 1.8 4.4l92.9 86.7z" />
    <path d="M345.2 171.9l-48.7-24.5-26.4 24.7 43.1 21.5-111.5 55.2-111.5-55.2 43.1-21.5-26.4-24.7-48.6 24.5c-3.1 1.6-5.1 4.8-5.1 8.3v138.2c0 3.6 2 6.8 5.1 8.3L197.5 397c1.3.7 2.7 1 4.2 1s2.8-.3 4.2-1l139.4-70.2c3.1-1.6 5.1-4.8 5.1-8.3V180.3c-.1-3.6-2.1-6.8-5.2-8.4z" />
  </svg>
);

export default extendIcon(Box);
